// extracted by mini-css-extract-plugin
export default {"primary":"Remove_primary__UgeHT","secondary":"Remove_secondary__7WwpW","circle":"Remove_circle__Xf67e"};